document.addEventListener('DOMContentLoaded', function() {
const gridModeButton = document.querySelector('.collection-view-mode-icon.collection-grid-mode-icon');
const listModeButton = document.querySelector('.collection-view-mode-icon.collection-list-mode-icon');
const rowModeButton = document.querySelector('.collection-view-mode-icon.collection-row-mode-icon');
const productList = document.querySelector('.product-list');

function toggleActiveClass(activeButton, ...inactiveButtons) {
  activeButton.classList.add('active');
  inactiveButtons.forEach(button => button.classList.remove('active'));
}

gridModeButton.addEventListener('click', function() {
  productList.classList.add('product-grid-mode');
  productList.classList.remove('product-list-mode', 'product-row-mode');
  toggleActiveClass(gridModeButton, listModeButton, rowModeButton);
});

listModeButton.addEventListener('click', function() {
  productList.classList.add('product-list-mode');
  productList.classList.remove('product-grid-mode', 'product-row-mode');
  toggleActiveClass(listModeButton, gridModeButton, rowModeButton);
});

rowModeButton.addEventListener('click', function() {
  productList.classList.add('product-row-mode');
  productList.classList.remove('product-grid-mode', 'product-list-mode');
  toggleActiveClass(rowModeButton, gridModeButton, listModeButton);
});



  //////////    filter sidebar block /////////////
  // const filterGroups = document.querySelectorAll(".sidebar-block");

  // filterGroups.forEach(filterGroup => {
  //   const summary = filterGroup.querySelector(".faceted-filter-group-summary");
  //   const display = filterGroup.querySelector(".faceted-filter-group-display");

  //   if (!summary || !display) return;

  //   // Function to handle responsiveness
  //   function handleResize() {
  //     // if (window.innerWidth <= 797) {
  //     //   display.classList.remove("show");
  //     //   summary.classList.remove("active");
  //     //   display.style.maxHeight = null;
  //     // } else {
  //     //   display.classList.add("show");
  //     //   summary.classList.add("active");
  //     //   display.style.maxHeight = display.scrollHeight + "px";
  //     // }
  //       display.classList.add("show");
  //       summary.classList.add("active");
  //       display.style.maxHeight = display.scrollHeight + "px";
  //   }

  //   // Run on page load and resize
  //   handleResize();
  //   window.addEventListener("resize", handleResize);

  //   // Toggle functionality on click
  //   summary.addEventListener("click", function () {
  //     display.classList.toggle("show");
  //     summary.classList.toggle("active");

  //     if (display.classList.contains("show")) {
  //       display.style.maxHeight = display.scrollHeight + "px"; // Expand
  //     } else {
  //       display.style.maxHeight = null; // Collapse
  //     }
  //   });
  // });

const filterGroups = document.querySelectorAll(".sidebar-block");

filterGroups.forEach(filterGroup => {
    const summary = filterGroup.querySelector(".faceted-filter-group-summary");
    const display = filterGroup.querySelector(".faceted-filter-group-display");

    if (!summary || !display) return;

    // Set initial state (Expanded)
    display.classList.add("show");
    summary.classList.add("active");

    // Toggle visibility on click
    summary.addEventListener("click", function () {
        if (display.classList.contains("show")) {
            display.style.maxHeight = "0px"; // Collapse
            display.classList.remove("show");
            summary.classList.remove("active");
        } else {
            display.style.maxHeight = display.scrollHeight + "px"; // Expand
            display.classList.add("show");
            summary.classList.add("active");
        }
    });
});






 $(".filter-toggle-button").click(function(){   
   console.log("drawer open ")
      $('body').addClass('filter_drawer-body')
     $('html').addClass('overflow:hidden')
      $(".filter-toggle-button").parents(".coll_section-custom").find(".faceted-filter-form").addClass("filter_drawer-open");
      $(".filter-toggle-button").parents(".coll_section-custom").find(".content-wrapper").addClass("filter_drawer-active");
     
  });
   $(".filter-drawer-close").click(function(){ 
      $('body').removeClass('filter_drawer-body')
     $('html').removeClass('overflow:hidden')
      $(this).parents(".faceted-filter-form").removeClass("filter_drawer-open"); 
      $(this).parents(".content-wrapper").removeClass("filter_drawer-active");
     
  });

});




// const selectors$v = {
//     rangeSlider: '[data-range-slider]',
//     rangeDotLeft: '[data-range-left]',
//     rangeDotRight: '[data-range-right]',
//     rangeLine: '[data-range-line]',
//     dataMin: 'data-se-min',
//     dataMax: 'data-se-max',
//     dataMinValue: 'data-se-min-value',
//     dataMaxValue: 'data-se-max-value',
//     dataStep: 'data-se-step'
// };

// class RangeSlider {
//     constructor(slider) {
//         this.slider = slider;
//         this.touchLeft = slider.querySelector(selectors$v.rangeDotLeft);
//         this.touchRight = slider.querySelector(selectors$v.rangeDotRight);
//         this.lineSpan = slider.querySelector(selectors$v.rangeLine);
//         this.min = parseFloat(slider.getAttribute(selectors$v.dataMin)) || 0;
//         this.max = parseFloat(slider.getAttribute(selectors$v.dataMax)) || 100;
//         this.step = parseFloat(slider.getAttribute(selectors$v.dataStep)) || 1;
//         this.init();
//     }
    
//     init() {
//         this.touchLeft.addEventListener('mousedown', this.onStart.bind(this));
//         this.touchRight.addEventListener('mousedown', this.onStart.bind(this));
//         this.touchLeft.addEventListener('touchstart', this.onStart.bind(this));
//         this.touchRight.addEventListener('touchstart', this.onStart.bind(this));
//         this.setDefaultValues();
//     }
    
//     setDefaultValues() {
//         let minValue = parseFloat(this.slider.getAttribute(selectors$v.dataMinValue)) || this.min;
//         let maxValue = parseFloat(this.slider.getAttribute(selectors$v.dataMaxValue)) || this.max;
//         this.setMinValue(minValue);
//         this.setMaxValue(maxValue);
//     }
    
//     onStart(event) {
//         event.preventDefault();
//         this.selectedTouch = event.currentTarget;
//         this.startX = event.touches ? event.touches[0].pageX : event.pageX;
//         this.startLeft = this.selectedTouch.offsetLeft;
//         document.addEventListener('mousemove', this.onMove.bind(this));
//         document.addEventListener('mouseup', this.onStop.bind(this));
//         document.addEventListener('touchmove', this.onMove.bind(this));
//         document.addEventListener('touchend', this.onStop.bind(this));
//     }
    
//     onMove(event) {
//         let moveX = (event.touches ? event.touches[0].pageX : event.pageX) - this.startX;
//         let newX = this.startLeft + moveX;
//         if (this.selectedTouch === this.touchLeft) {
//             newX = Math.max(0, Math.min(newX, this.touchRight.offsetLeft - 10));
//         } else {
//             newX = Math.min(this.slider.offsetWidth - this.selectedTouch.offsetWidth, Math.max(newX, this.touchLeft.offsetLeft + 10));
//         }
//         this.selectedTouch.style.left = newX + 'px';
//         this.updateRange();
//     }
    
//     onStop() {
//         document.removeEventListener('mousemove', this.onMove.bind(this));
//         document.removeEventListener('mouseup', this.onStop.bind(this));
//         document.removeEventListener('touchmove', this.onMove.bind(this));
//         document.removeEventListener('touchend', this.onStop.bind(this));
//         this.selectedTouch = null;
//     }
    
//     setMinValue(value) {
//         let ratio = (value - this.min) / (this.max - this.min);
//         this.touchLeft.style.left = ratio * (this.slider.offsetWidth - this.touchLeft.offsetWidth) + 'px';
//         this.updateRange();
//     }
    
//     setMaxValue(value) {
//         let ratio = (value - this.min) / (this.max - this.min);
//         this.touchRight.style.left = ratio * (this.slider.offsetWidth - this.touchRight.offsetWidth) + 'px';
//         this.updateRange();
//     }
    
//     updateRange() {
//         this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
//         this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
//         let minValue = Math.round(this.min + (this.touchLeft.offsetLeft / (this.slider.offsetWidth - this.touchLeft.offsetWidth)) * (this.max - this.min));
//         let maxValue = Math.round(this.min + (this.touchRight.offsetLeft / (this.slider.offsetWidth - this.touchRight.offsetWidth)) * (this.max - this.min));
//         this.slider.setAttribute(selectors$v.dataMinValue, minValue);
//         this.slider.setAttribute(selectors$v.dataMaxValue, maxValue);
//     }
// }

// document.addEventListener('DOMContentLoaded', function () {
//     document.querySelectorAll(selectors$v.rangeSlider).forEach(slider => new RangeSlider(slider));
// });

const selectors = {
    rangeSlider: '[data-range-slider]',
    rangeDotLeft: '[data-range-left]',
    rangeDotRight: '[data-range-right]',
    rangeLine: '[data-range-line]',
    priceMin: '.faceted-filter-group-display__price-range-from input',
    priceMax: '.faceted-filter-group-display__price-range-to input'
};

document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector(selectors.rangeSlider);
    const leftHandle = slider.querySelector(selectors.rangeDotLeft);
    const rightHandle = slider.querySelector(selectors.rangeDotRight);
    const line = slider.querySelector(selectors.rangeLine);
    const minInput = document.querySelector(selectors.priceMin);
    const maxInput = document.querySelector(selectors.priceMax);
    
    let minValue = parseFloat(slider.getAttribute('data-se-min-value')) || 0;
    let maxValue = parseFloat(slider.getAttribute('data-se-max-value')) || 3250;
    let min = parseFloat(slider.getAttribute('data-se-min')) || 0;
    let max = parseFloat(slider.getAttribute('data-se-max')) || 3250;

    function updateHandles() {
        const range = max - min;
        const leftPercent = ((minValue - min) / range) * 100;
        const rightPercent = ((maxValue - min) / range) * 100;
        
        leftHandle.style.left = `${leftPercent}%`;
        rightHandle.style.left = `${rightPercent}%`;
        line.style.marginLeft = `${leftPercent}%`;
        line.style.width = `${rightPercent - leftPercent}%`;
    }

    function updateInputs() {
        minInput.setAttribute('data-se-min-value', minValue);
        maxInput.setAttribute('data-se-max-value', maxValue);
        minInput.value = minValue;
        maxInput.value = maxValue;
    }

    function onHandleMove(event, isLeft) {
        event.preventDefault();
        let startX = event.clientX || event.touches[0].clientX;
        let startValue = isLeft ? minValue : maxValue;
        
        function onMove(e) {
            let clientX = e.clientX || e.touches[0].clientX;
            let diff = ((clientX - startX) / slider.offsetWidth) * (max - min);
            let newValue = Math.round(startValue + diff);
            
            if (isLeft) {
                minValue = Math.max(min, Math.min(newValue, maxValue - 1));
            } else {
                maxValue = Math.min(max, Math.max(newValue, minValue + 1));
            }
            updateHandles();
            updateInputs();
        }

        function onStop() {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onStop);
        }
        
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onStop);
    }

    leftHandle.addEventListener('mousedown', (e) => onHandleMove(e, true));
    rightHandle.addEventListener('mousedown', (e) => onHandleMove(e, false));

    minInput.addEventListener('input', () => {
        minValue = Math.max(min, Math.min(parseFloat(minInput.value) || min, maxValue - 1));
        updateHandles();
    });

    maxInput.addEventListener('input', () => {
        maxValue = Math.min(max, Math.max(parseFloat(maxInput.value) || max, minValue + 1));
        updateHandles();
    });

    updateHandles();
    updateInputs();
});
// window.addEventListener("load", function () {
//     let titles = document.querySelectorAll(".product-details .title");
//     let maxHeight = 0;
 
//     titles.forEach(title => {
//         if (title.clientHeight > maxHeight) {
//             maxHeight = title.clientHeight;
//         }
//     });
 
//     titles.forEach(title => {
//         title.style.height = maxHeight + "px";
//     });
// });
document.addEventListener("DOMContentLoaded", function () {
    function setEqualHeight() {
        let titles = document.querySelectorAll(".title");
        let container = document.querySelector(".product-list--collection .column");
        let productsPerRow = window.innerWidth <= 768 ? 2 : 4; // Mobile: 2, Desktop: 4
        let rows = [];

        // Divide products into rows
        for (let i = 0; i < titles.length; i += productsPerRow) {
            let rowItems = Array.from(titles).slice(i, i + productsPerRow);
            rows.push(rowItems);
        }

        // Reset height before calculation (for responsiveness)
        titles.forEach(title => title.style.height = "auto");

        // Set equal height for each row
        rows.forEach(row => {
            let maxHeight = Math.max(...row.map(title => title.clientHeight));
            row.forEach(title => title.style.height = maxHeight + "px");
        });
    }

    // Run on page load & window resize
    setEqualHeight();
    window.addEventListener("resize", setEqualHeight);
});
